<template>
  <transition>
    <div class="loading-backdrop">
      <div class="loading"
           role="dialog"
           aria-labelledby="loadingTitle"
           aria-describedby="loadingDescription"
      >
        <div class="spinnerWrap">
          <ring-loader :loading="loading"></ring-loader>
        </div>

        <div class="commentWrap">
          <h2>{{comment}}</h2>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import RingLoader from "vue-spinner/src/RingLoader";

  export default {
    name: "full-loading",
    components: {
      RingLoader
    },
    props: ['comment'],
    computed: {},
    watch: {},
    methods: {
    },
    data() {
      return {
        loading : true ,
      }
    },
    created() {

    },
    updated() {

    },
    mounted() {

    },


  }
</script>

<style scoped lang="scss">
  .loading-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    .loading {
      //background-color: rgba(255, 255, 255, 0.3);
      width:50%;
      height:50%;
      //background: #FFFFFF;
      //box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .spinnerWrap{

      }
      .commentWrap {
        margin-top:2rem;
        color:#fff;
        font-weight: 300;
        >h2{
          font-weight: 400;

        }
      }
    }
  }

  /*.modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/menu/layouts/FullLoading.vue